var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bindsApp"}},[_c('Widget',_vm._b({},'Widget',{ ..._vm.$props, ..._vm.$attrs },false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }